import gql from "graphql-tag";
const getGhostQuery = gql(` 
query GetGhost($params: AWSJSON!) {
  getGhost(params: $params) {
    id
    status
    profile
    penalty
    cycles
    batches
    nearest
    distance
    geo
    quantity
    filtered
    result
  }
}
`)
export default getGhostQuery;